import { render, staticRenderFns } from "./LinkTo.vue?vue&type=template&id=4be23dc4&"
import script from "./LinkTo.vue?vue&type=script&lang=js&"
export * from "./LinkTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports